// Owner/director Management pane on pages that do not have their own
// Management content yet. Named, not blank (INV-9). The owner will say
// what each section holds.
import type { JSX } from 'preact';

/** Owner, 2026-10-06 ("yes to all" on the view-differences audit): the
 * empty Management tabs on Tasks, Money and Reports are HIDDEN, for everyone,
 * until they have content — a tab that only says "not set yet" is clutter.
 * The code paths stay; flip this (or give that page its own content) to
 * bring a tab back. People and Company have real Management content and do
 * not read this. */
export const SHOW_EMPTY_MANAGEMENT_TABS: boolean = false;

export function ManagementPlaceholder({ section }: { section: string }): JSX.Element {
  return (
    <div class="card" data-testid="management-placeholder">
      <div class="section-head">
        <h2>Management</h2>
        <p>{section} — what belongs here is not set yet.</p>
      </div>
    </div>
  );
}
